module.exports = __webpack_public_path__ + "static/media/test19_4.a9e211b5.png";